import React from 'react'
import { SetModal, ModalType } from '../..'
import WithdrawalModal from '../WithdrawalModal'
import { useAppSelector } from '@/redux'

import RecordItem from '../RecordItem'
import { useGetBalanceQuery, initialBalance } from '../../walletSlice'
import WithdrawTitle from '../WithdrawTitle'
import Billing from './Billing'
import useWithdrawParams from './useWithdrawParams'
import { useGetUserInfoQuery } from '@/utils/slices/accountSlice'
import { WITHDRAWAL_TIPS } from '../../constants'
import { Dialog } from 'antd-mobile'
export default function Monthly({
  setModal,
  modalStatus,
}: {
  setModal: SetModal
  modalStatus: ModalType
}) {
  const { data: balance = initialBalance } = useGetBalanceQuery(0)

  const { collectionInfoFilled, idenAuthenticationed } = useAppSelector(
    (state) => state.user,
  )

  const withdrawParams = useWithdrawParams()
  const { data: userInfo } = useGetUserInfoQuery()

  const goWithdraw = () => {
    setModal(
      !idenAuthenticationed
        ? 'requiredIdentify'
        : !collectionInfoFilled
        ? 'requiredCollectionInfo'
        : 'withdrawaling',
    )
  }
  const handleWithdraw = () =>{
      if(userInfo?.isMigrated){
        Dialog.confirm({
          title:'提示',
          content: WITHDRAWAL_TIPS['month'],
          onConfirm: () => {
            goWithdraw()
          },
        })
      }else{
        goWithdraw()
      }
    }
  return (
    <div>
      <WithdrawTitle
        text={`注意：每月${withdrawParams.timeRangeRaw[0]}日~${withdrawParams.timeRangeRaw[1]}日可提现1次，提现额度￥${withdrawParams.amountLimit[0]}~${withdrawParams.amountLimit[1]}元。`}
        disabled={!withdrawParams.available}
        onClick={handleWithdraw}
        title="月结钱包"
        balance={balance}
      ></WithdrawTitle>
      <Billing />
      <RecordItem type="monthly-entry"></RecordItem>
      <RecordItem type="monthly-withdraw"></RecordItem>
      {modalStatus === 'withdrawaling' && (
        <WithdrawalModal
          visible={!!modalStatus}
          onFinishWithdrawal={() => setModal('')}
          walletType={0}
          withdrawParams={withdrawParams}
        ></WithdrawalModal>
      )}
    </div>
  )
}
